export enum AccountState {
    'NEW', 'PENDING', 'REJECTED', 'ACTIVE', 'DISABLE_REQUEST', 'DISABLED', 'DELETED'
}
